import Link from "next/link"
import DOMPurify from "isomorphic-dompurify"
import DynamicImage from "./DynamicImage"
import { getShortenedUrlwithGeneral } from "@/utils/helper"
import { useEffect, useState } from "react"
import { getConfig } from "@/constants/config"

const FaqBanner = props => {
  const {
    data: {
      id: uniqueId = "",
      alt = "",
      src: imgUrl = "",
      imageComponentProperties = {
        src: "",
        alt: "",
      },
      title,
      description,
      appliedCssClassNames,
      imageResource = {
        imageserverurl:"",
        imageServerUrl:"",
        assetID:""
      },
      actions,
    } = {},
  } = props

  const {
    imageServerUrl = "",
    imageserverurl = "",
    assetID = "",
  } = imageResource || {}
  const imageBaseUrl = imageServerUrl || imageserverurl
  const hasImage = Boolean(imageBaseUrl && assetID)
  const imageUrl = imageBaseUrl?.endsWith("/")
    ? `${imageBaseUrl}${assetID}`
    : `${imageBaseUrl}/${assetID}`

  const [general, setGeneral] = useState()

  useEffect(() => {
    const configFn = async () => {
      const { general } = await getConfig()
      setGeneral(general)
    }

    if (hasImage) {
      configFn()
    }
  }, [hasImage])

  if (!hasImage) return null

  return (
    <div className={`image ${appliedCssClassNames ? appliedCssClassNames : ""}`} id="image">
      <div className="eaem-bounding-div">

        <div className="faq-banner-image">
          <div className="faq-image_resource">
            <DynamicImage
              {...{
                uniqueId,
                imgUrl: imageUrl,
                alt: alt || imageComponentProperties.alt,
                className: "faq-image__image transition",
              }}
            />
          </div>
          <div className="faq-banner-image_details">
            {title ? (
              <span
                className="faq-banner-image__title"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(title),
                }}
              />
            ) : (
              ""
            )}
            <span className="faq-banner-image__description_pannel">
              {description ? (
                <span
                  className="faq-banner-image__description_text"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(description),
                  }}
                />
              ) : (
                ""
              )}
              {actions && actions.length > 0 && (
                <div className="faq-banner-image__description_buttons">
                  {actions.map((item, index) => (
                    <span key={item.id || index}>
                      <Link
                        href={getShortenedUrlwithGeneral(item.url, general)}
                        underline={true}
                        className="faq-banner-image__description_button"
                        target={item.newTab ? '_blank' : '_self'}
                        rel="noreferrer"
                      >
                        {item.title}
                      </Link>
                    </span>
                  ))}
                </div>
              )}
            </span>

          </div>
        </div>
      </div>
    </div>
  )
}

export default FaqBanner
